var _rect, _circle, _path, _rect2, _rect3, _rect4, _rect5, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJobconfigBindingCombShortLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 115,
    viewBox: "0 0 80 115",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 9,
    width: 80,
    height: 106,
    rx: 4,
    fill: "#BCBDC0"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 41,
    cy: 62.4443,
    r: 25,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.8453 74.333H52.2453V60.533C52.2453 57.133 52.2453 49.733 41.9953 49.733C38.1953 49.733 34.4453 50.883 31.7953 53.583L34.9453 56.733C36.5453 55.233 38.8453 54.233 41.3453 54.233C44.5453 54.233 46.8453 55.783 46.8453 58.733V59.383H45.3453C39.3453 59.383 30.2453 59.933 30.2453 67.733C30.2453 72.483 34.5453 74.933 38.9953 74.933C42.1953 74.933 44.9953 73.733 46.6953 71.033H46.8453V74.333ZM46.4953 64.933C46.4953 68.283 44.5453 70.433 40.4453 70.433C38.4953 70.433 36.2453 69.483 36.2453 67.283C36.2453 63.833 41.9453 63.583 45.2453 63.583H46.4953V64.933Z",
    fill: "#52B3A7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 71,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 71 16.999)",
    fill: "#52B3A7"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 51 16.999)",
    fill: "#52B3A7"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 31 16.999)",
    fill: "#52B3A7"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 16.999,
    width: 3,
    height: 14,
    rx: 1.5,
    transform: "rotate(-180 11 16.999)",
    fill: "#52B3A7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 4.99902L8 2.99901C8 1.34216 9.34315 -0.000984969 11 -0.000984752L68 -0.000977278C69.6569 -0.00097706 71 1.34217 71 2.99902L71 4.99903L8 4.99902Z",
    fill: "#52B3A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJobconfigBindingCombShortLeft);
export default __webpack_public_path__ + "static/media/jobconfig-binding-comb-short-left.0ab1e68be1caa3d2f73256651e4db33b.svg";
export { ForwardRef as ReactComponent };